import { createAction } from 'redux-actions';

export const requestGetClientDetailsAction = createAction('REQUEST/CLIENT_DETAILS');
export const requestUpdateClientDetailsAction = createAction('REQUEST/UPDATE_CLIENT_DETAILS');
export const requestUpdateClientStatusAction = createAction('REQUEST/UPDATE_CLIENT_STATUS');
